<template>
  <section class="content-section">
    <b-container>
      <b-row>
        <b-col
          class="mb-4"
          cols="12"
          md="6"
          v-for="(info, i) in infos"
          :key="i"
        >
          <div class="card p-3">
            <h5 class="text-info">{{ info.title }}</h5>
            <p class="m-0">{{ info.name }}</p>
            <p class="">{{ info.ename }}</p>
            <b-img :src="info.img" fluid class="mb-3" />
            <dl>
              <dt><span class="badge badge-info">地址 Address</span></dt>
              <dd>{{ info.detail.addr }}</dd>
              <dt><span class="badge badge-info">電話 Tel no.</span></dt>
              <dd>{{ info.detail.tel }}</dd>
              <dt><span class="badge badge-info">傳真 fax</span></dt>
              <dd>{{ info.detail.fax }}</dd>
              <dt><span class="badge badge-info">E-mail</span></dt>
              <dd>{{ info.detail.email }}</dd>
              <dt><span class="badge badge-info">統一編號 Tax id No.</span></dt>
              <dd>{{ info.detail.taxId }}</dd>
              <dt v-if="info.detail.wechat">
                <span class="badge badge-info">微信公眾號 WeChat</span>
              </dt>
              <dd v-if="info.detail.wechat">
                <a :href="info.detail.wechat.link" target="_blank">{{
                  info.detail.wechat.title
                }}</a>
              </dd>
            </dl>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data() {
    return {
      infos: [
        {
          title: "全球營運中心 Global Business Center",
          name: "金頂實業股份有限公司",
          ename: "Scan Top Enterprise CO., LTD",
          img: require("@/assets/images/contact/scantop.jpg"),
          detail: {
            addr: "22069 台灣新北市板橋區民生路一段33號22樓之2 22F-2, No. 33, Sec. 1, Minsheng Rd.,Banqiao Dist., New Taipei City 22069, Taiwan",
            tel: "886-2-2957-3478",
            fax: "886-2-2957-3288",
            email: "wiper@scantop.com.tw",
            taxId: "86468320",
          },
        },
        {
          title: "金頂集團旗下工廠 Owned Plant",
          name: "丹陽鎮威汽配有限公司",
          ename: "DANYANG UPC AUTO PARTS CO., LTD.",
          img: require("@/assets/images/contact/upc.jpg"),
          detail: {
            addr: "中國江蘇省丹陽市界牌鎮大成橋工業園區 郵編 212323 dachengqiao industrial park,jiepai town danyang city, jiangsu, china post code: 212323",
            tel: "86-511-8638-0701",
            fax: "86-511-8638-0700",
            email: "wiper@scantop.com.tw",
            taxId: "91321181732518702A",
          },
        },
      ],
    };
  },
};
</script>